





import { defineComponent, computed, ref, PropType, toRefs } from '@vue/composition-api';
import TipAlert from '@/components/common/tip-alert/index.vue';
import { StateEnum, useAdgroupLocation, useStore } from '@tt4b/ttam-hooks';
import { AdgroupFormData } from '@tt4b/ttam-enums';

const name = 'ttam-pangle-support-city-location-tips';
export default defineComponent({
  components: {
    TipAlert,
  },
  props: {
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
  },
  setup(props) {
    const { adgroupData } = toRefs(props);
    const { state } = useStore();
    const areaData = state[StateEnum.areaData].data;
    const areaMap = computed(() => areaData?.value?.areaMap ?? {});
    const unsupportedCountriesIds = computed(() => areaData?.value?.unsupportedCountryIds ?? []);
    const { supportCityLevelTips: tips } = useAdgroupLocation({
      adgroupFormData: adgroupData,
      areaMap,
      areaList: ref([]),
      accountCountry: ref(''),
      unsupportedCountriesIds,
    });

    return {
      name,
      tips,
    };
  },
});
